import { Typography } from "@material-ui/core";
import React, { useCallback, useState, useContext } from "react";
import { useFormContext } from "react-hook-form";
import aircraftApi from "../../../api/aircraft.api";
import { DEBOUNCE_TIME } from "../../../Constants";
import { debounce } from "../../../services/utils";
import { BetterControlledAutocomplete, ControlledTextField } from "../../Core/Form/ControlledFields";
import { QuoteContextStore } from '../../../context/QuoteContext/QuoteContext';


const AircraftMakeAutocomplete = ({...props}) => {
    const [isLoading, setIsLoading] = useState(false);
    const [makes, setMakes] = useState([]);
    const { watch, reset, getValues } = useFormContext();
    const {locked_quote} = useContext(QuoteContextStore)

    const notFound = watch("make_model_not_found");

    async function filter(make, model, year) {
        setIsLoading(true);
        if(!make) {
            const { data: { aircraft_makes }} = await aircraftApi.getMakes("" , "", "");
            setMakes(aircraft_makes);
            setIsLoading(false);
            return;
        }
        if(make.length < 1) {
            const { data: { aircraft_makes }} = await aircraftApi.getMakes("" , "", "");
            setMakes(aircraft_makes);
            setIsLoading(false);
            return;
        }
        const { data: { aircraft_makes }} = await aircraftApi.getMakes(make , "", "");
        setMakes(aircraft_makes);
        setIsLoading(false);

    }
    
    const debounceHandler = useCallback(debounce(filter, DEBOUNCE_TIME), []);

    const handleFiltering = (e) => {
        if(!e) return;
        const { value } = e.target;
        debounceHandler(value, "", "");
        const oldForm = {...getValues()};
        // reset({...oldForm, make: value, model: "", year: "", min_value: 0, max_value: 550000})
        console.log("handleFiltering")
    }

    const handleAircraftPick = async (e, value) => {
        reset({...getValues(), model: null, year: null, min_value: 0, max_value: 550000})
        console.log("handleAircraftPick")

    }

    const handleOnFocus = async () => {
        setIsLoading(true);
        const { data: { aircraft_makes }} = await aircraftApi.getMakes("" , "", "");
        setMakes(aircraft_makes);
        setIsLoading(false);
        console.log("handleOnFocus")

    }

    return <>
        <Typography variant="h4" className="gray">Aircraft make</Typography>
        {!notFound ? <BetterControlledAutocomplete isLoading={isLoading} name="make" onFocus={handleOnFocus} className="margin-top-8" onChange={handleAircraftPick} onInputChange={handleFiltering} placeholder="Make" options={makes} disabled={locked_quote}/> :
        <>
        <ControlledTextField fullWidth name="make" className="margin-top-8" placeholder="Make" disabled={locked_quote}/>
        <Typography variant="body1" className="margin-top-10">Please Type your make, model and year</Typography>
        </>
        }
    </>
}

export default AircraftMakeAutocomplete;